import {
  type NavigateOptions,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';

// Parameters to keep in the URL

export const useNavigateWithParams = (
  paramsToKeep?: string[]
): ((path: string, options?: NavigateOptions) => void) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const navigateWithParams = (
    path: string,
    options: NavigateOptions = {}
  ): void => {
    // Filter the parameters we want to retain
    let paramsKept: Record<string, string> = {};
    if (paramsToKeep) {
      paramsKept = paramsToKeep.reduce(
        (acc, param) => {
          const value = searchParams.get(param);
          if (value) {
            acc[param] = value;
          }
          return acc;
        },
        {} as Record<string, string>
      );
    } else {
      paramsKept = Object.fromEntries(searchParams.entries());
    }

    // Build the new URL with the retained parameters
    const url = new URL(path, window.location.origin);
    Object.entries(paramsKept).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });

    // Navigate to the new URL
    navigate(`${url.pathname}${url.search}`, options);
  };
  return navigateWithParams;
};
